module.exports = __webpack_public_path__ + "img/LV3.73524d3c.svg";